import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from 'common/utils/customBaseQuery';

const settingsBaseUrl = '/settings';

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getSettings: builder.query<SettingsData[], SettingsParams>({
      query: (params) => ({
        url: settingsBaseUrl,
        params,
      }),
    }),
  }),
});

export const { useLazyGetSettingsQuery } = settingsApi;
